export default __webpack_public_path__ + "static/media/avatar-supervisor.8f3449ef.jpg";